import { ReactElement } from 'react';

import { Message, TextView } from '@dreryk/react-components';

import { onlinePaymentsProviderDetailsTranslationKeys } from '../../translations';

import { useOptions } from './OnlinePaymentsIntegrationStatus.hooks';
import { OnlinePaymentsIntegrationStatusLoader } from './OnlinePaymentsIntegrationStatus.loader';
import { getStatusLabel, messageTypes } from './OnlinePaymentsIntegrationStatus.utils';

export const OnlinePaymentsIntegrationStatus = (): ReactElement => {
   const statusOptions = useOptions();

   return (
      <TextView
         testId={'integrationStatusLabel'}
         label={onlinePaymentsProviderDetailsTranslationKeys.generalInformation.integrationStatus.label}
      >
         <OnlinePaymentsIntegrationStatusLoader>
            {({ onlinePaymentsAuthorizationConfiguration }) => (
               <Message
                  testId={'integrationStatus'}
                  options={statusOptions}
                  type={messageTypes[onlinePaymentsAuthorizationConfiguration.status]}
                  displayIndicator
                  label={getStatusLabel(onlinePaymentsAuthorizationConfiguration)}
               />
            )}
         </OnlinePaymentsIntegrationStatusLoader>
      </TextView>
   );
};
